<h5 class="mb-2 appTooltip"
    appTooltip="{{consts.HEADER_TRENDING}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>
<div *ngIf="activeIndex === 0" class="arrow-wrapper dxc-purple">
    <button
        mat-icon-button
        class="button-arrow"
        (click)="pre()"
        [disabled]="fs < linksPerPage"
    >
        <mat-icon svgIcon="hub_chevron_left"></mat-icon>
    </button>
    <button
        mat-icon-button
        class="button-arrow"
        (click)="next()"
        [disabled]="fs >= linksPerPage"
    >
        <mat-icon svgIcon="hub_chevron_right"></mat-icon>
    </button>
</div>
<div class="row">
    <div class="col-lg-2 col-md-2 col-sm-2 nav-menu">
        <a *ngFor="let nav of consts.NAV_MENU_OPTION; let i = index"
            class="active"
            [class.active]="activeIndex === i"
            (click)="showInformation(nav.TITLE)"
            appTooltip="{{nav.TOOLTIP_MESSAGE}}"
            tooltipPosition="right"
            tooltipCustomClass="nav-menu-link-tooltip"
        >
            {{nav.TITLE}}
        </a>
    </div>
    <div class="trending-container">
        <ng-container *ngIf="activeIndex === 0">
            <app-trending-documents [ls]=ls [fs]=fs></app-trending-documents>
        </ng-container>
        <ng-container *ngIf="activeIndex === 1">
            <app-trending-hrconnect [countryList]=countryList></app-trending-hrconnect>
        </ng-container>
        <ng-container *ngIf="activeIndex === 2">
            <app-trending-itconnect></app-trending-itconnect>
        </ng-container>
    </div>
</div>
